var link_viewer_default = {
  "fontElementMap": "_4q5dZ",
  "link": "q2QVv",
  "linkInEditor": "V4Avg",
  "linkInViewer": "oiVLY",
  "toolbarUrlContainer": "SpkGO",
  "toolbarUrl": "sJAHe",
  "toolbarUrlAnchor": "_69Fho"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
